<template>
  <div>
    <div class="input-wrapper">
      <div class="form-group m-d-gruop"
        :id="element.id"
        :class="{ 'invalid-field': (submitted && checkErr(errors, element)) || (!submitted && element.is_invalid && element.value == element.originalValue) }">
        <b-form-input @input="setResponseErrors(null)" :type="element.key_type" v-model="element.value" :disabled="getReAuth && !element.editable" required
          :maxLength="element.validation.maxLength ? element.validation.maxLength : null"/>
        <label for="field.key_code">{{ element.name }}</label>
      </div>
    </div>
    <div class="err-wrapper" style="margin-top:12px">
      <div v-if="submitted && !element.value && element.validation.required">
        <span class="error-value">{{ element.name }} is required.</span>
      </div>
      <div v-if="!submitted && element.value && element.is_invalid && element.value == element.originalValue">
        <span class="error-value">Sorry, invalid {{ element.name }}.</span>
      </div>
      <div v-for="(error, index) in errors" :key="index">
        <div v-if="
          !error.general_error && error.key == element.key_code && submitted
        ">
          <span class="error-value">{{ error.message }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["element", "index", "submitted", "errors", "getReAuth"],
  methods: {
    ...mapActions("integration", [
      "setResponseErrors",
    ]),
    checkErr(errors, element) {
      console.log("checkerr", element, !element.value, errors);
      if (!element.value && element.validation.required) return true;
      let invalid = false;
      if (errors && errors.length > 0)
      errors.map((error) => {
        if (error && !error.general_error && error.key == element.key_code) {
          // console.log("true");
          invalid = true;
        }
      });
      // console.log('invalid', invalid);
      // return !!err;
      return invalid;
    },
  },
};
</script>

<style lang="scss">
.invalid-field {
  border: 1.5px solid #f46a6a !important;
  border-radius: 4px !important;
}
</style>

